module.exports = __webpack_public_path__ + "static/media/img.c3fa1372.png";